<template>
    <div class="kgk-user-runs">
        <!--<h1>Topliste Läufer</h1>-->
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="runs">
            <div v-if="runs.length > 0">
                <ul class="kgk-pagination">
                    <li v-for="page in pages" :key="page">
                        <router-link :to="'/admin/runs/' + page">{{ page }}</router-link>
                    </li>
                </ul>
                <table>
                    <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <!--<td>Avatar</td>-->
                        <th width="40">&nbsp;</th>
                        <th>Läufer</th>
                        <th>Distanz</th>
                        <th>Dauer</th>
                        <th>Pace</th>
                        <th>Zeitpunkt</th>
                        <th>Foto?</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(run, index) in pageRuns"
                        :key="run.identifier">
                        <td>
                            <span class="kgk-ranking-num">{{ runs.length - index - (page - 1) * runsPerPage }}.</span>
                        </td>
                        <td>
                            <div class="kgk-avatar kgk-avatar--list" v-kgk-avatar="run.avatar_url"></div>
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Läufer:</div>
                            {{ run.username }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Distanz:</div>
                            <i class="fas fa-running"></i> {{ convertNumberReadable(Math.round(run.length * 100) / 100) }} km
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Dauer:</div>
                            <i class="fas fa-stopwatch"></i> {{ durationReadable(run.duration) }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Pace:</div>
                            {{ convertNumberReadable(Math.round((run.duration / 60) / run.length * 100) / 100) }} min/km
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Zeitpunkt:</div>
                            <i class="fas fa-calendar-alt"></i> {{ convertDateReadable(run.ran_at) }} <i class="fas fa-clock"></i> {{ convertTimeReadable(run.ran_at) }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Foto?:</div>
                            <span v-if="run.invalidated" class="kgk-error" v-tooltip="'Nachweisfoto /-screenshot wurde nicht akzeptiert'">
                                <i class="fas fa-exclamation-triangle"></i>
                            </span>
                            <span v-else-if="run.valid">
                                <i class="fas fa-check"></i>
                                <!--<i v-if="run.screenshot_url" class="fas fa-check" :v-tooltip="getScreenshotTooltipContent(run.screenshot_url)"></i>
                                <i v-else class="fas fa-check"></i>-->
                            </span>
                            <span v-else v-tooltip="'Nachweisfoto /-screenshot fehlt'">
                                <i class="fas fa-times"></i>
                                <!--<i class="fas fa-info-circle"></i>-->
                            </span>
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Aktionen:</div>
                            <div class="kgk-actions">
                                <a v-if="run.valid && !run.invalidated" @click.prevent="editRunButton(run)" href="#" title="Lauf überprüfen">
                                    <i class="fas fa-image"></i>
                                </a>
                                <!--<a @click.prevent="deleteRunButton(run)" href="#" title="Lauf löschen">
                                    <i v-if="!run.loading" class="fas fa-trash fa-fw"></i>
                                    <i v-else class="fas fa-spinner fa-spin fa-fw"></i>
                                </a>-->
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <ul class="kgk-pagination">
                    <li v-for="page in pages" :key="page">
                        <router-link :to="'/admin/runs/' + page">{{ page }}</router-link>
                    </li>
                </ul>
            </div>
            <div v-else>
                <div class="spacer"></div>
                <p>Es wurde bisher noch keinen Lauf eingetragen.</p>
            </div>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import admin from '../../api/admin';
    import InvalidateRunForm from './InvalidateRunForm';
    //import InvalidateRunForm from './InvalidateRunForm';

    export default {
        name: 'RunsInvalidation',
        props: {
            page: Number,
            runsPerPage: {
                type: Number,
                required: false,
                default: 20,
            }
        },
        data() {
            return {
                runs: [],
                loading: false,
                error: null,
            }
        },
        computed: {
            lastPage() {
                return Math.ceil(this.runs.length / this.runsPerPage);
            },
            pages() {
                //return [...Array(this.lastPage).keys()].map(i => i + 1);
                return Array(this.lastPage).fill(1).map((i, offset) => i + offset);
            },
            pageRuns() { // slice
                const start = (this.page - 1) * this.runsPerPage;
                return this.runs.slice(start, start + this.runsPerPage);
            },
        },
        methods: {
            loadRuns() {
                this.loading = true;

                admin.getRuns(
                    this,
                    data => this.runs = data.runs,
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => this.loading = false,
                );
            },
            durationReadable(duration) {
                const hours = Math.floor(duration / 60 / 60);
                const minutes = Math.floor((duration % (60 * 60)) / 60);
                const seconds = duration % 60;

                //return (hours > 0 ? hours + ':' : '') + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
                return hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
            },

            editRunButton(run) {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Lauf invalidieren';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    }
                };

                this.$modal.show('dialog', {
                    title: 'Lauf invalidieren',
                    component: InvalidateRunForm,
                    class: 'button-cta-error',
                    props: {
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger,
                        runIdentifier: run.identifier,
                    },
                    on: {
                        invalidated: _this.handleInvalidatedFactory(run),
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            //default: true,
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            handleInvalidatedFactory(run) {
                return () => {
                    //console.log('handleInvalidated', this);
                    //this.selection = selectedUsers;

                    run.invalidated = true;

                    this.$modal.hide('dialog');

                    this.$emit('invalidated');
                }
            },

            deleteRunButton(run) {
                const _this = this;

                let fired = false;

                this.$modal.show('dialog', {
                    title: 'Lauf löschen',
                    text: `Möchten Sie den Lauf über <b>${run.length} km</b> vom ${run.ran_at} Uhr wirklich löschen?`,
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                        },
                        {
                            title: 'Ja, löschen',
                            handler() {
                                if( fired ) {
                                    return;
                                }

                                fired = true;
                                this.title += ' <i class="fas fa-spinner fa-spin"></i>';
                                _this.deleteRun(run, () => _this.$modal.hide('dialog'));
                            }
                        }
                    ]
                });
            },
        },
        watch: {

        },
        mounted() {
            this.loadRuns();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
